var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSampleTwoColumns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n.back { fill: #ffffff; stroke: #888888 }\n.loop { fill: #ffffff; stroke: #ff9185 }\n.text { fill: #eeeeee; stroke: #cccccc }\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    className: "back"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 180,
    height: 40,
    className: "text"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 60,
    width: 85,
    height: 80,
    className: "text"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 60,
    width: 85,
    height: 80,
    className: "text"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 150,
    width: 180,
    height: 40,
    className: "text"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSampleTwoColumns);
export default __webpack_public_path__ + "static/media/sampleTwoColumns.7d6c19bb2670ceb402ef96283a2d743b.svg";
export { ForwardRef as ReactComponent };